<!-- 
	News
	props: N/A
  	role: User
	Called by @/views/User to display lottery news items to users
  	If news item is current date or past then display
-->

<template>
	<div class="news bg-white p-4 sm:p-8 text-black min-w-full">
		<div class="text-3xl">Lottery News</div>
		<div v-if="this.loading === false && this.news.length > 0">
			<div v-for="item in news" :key="item.publishDate">
				<div class="news-item">
					<div class="text-2xl pb-4">
						{{ item.title }}
					</div>
					<div v-html="item.content"></div>
					<div v-if="item.hyperlink">
						<a :href="item.hyperlink">
							<CustomButton>{{ item.hyperlinkText }}</CustomButton>
						</a>
					</div>
				</div>
			</div>
		</div>
		<div v-else-if="this.loading === false && this.news.length === 0">
			<div class="text-lg py-4">No Lottery News Yet</div>
			<div>Check back soon!</div>
		</div>
		<div v-else class='my-4'>
			<Loading />
		</div>
	</div>
</template>
<script>
	import firebase from "firebase";

	import CustomButton from "@/components/CustomButton";
	import Loading from "@/components/Loading";

	export default {
		name: "News",
		props: ["user"],
		components: {
			CustomButton,
			Loading,
		},
		data() {
			return {
				news: [],
				loading: true,
				today: "",
			};
		},
		async created() {
			// set todays date in this.today
			const fullDate = new Date();

			const year = fullDate.getUTCFullYear();
			const month = fullDate.getUTCMonth() + 1;
			const day = fullDate.getUTCDate();

			// if day is single digit prepend zero before day
			let zero = "";
			if (day.toString().length === 1) {
				zero = 0;
			}

			const today = year + "-" + month + "-" + zero + day;

			this.today = today;

			const db = firebase.firestore().collection("news");
			try {
				// get news items and limit to three sorting by publish date
				db.orderBy("publishDate", "desc")
					.get()
					.then((querySnapshot) => {
						querySnapshot.forEach((doc) => {
							if (doc.data().publishDate <= today && (doc.data().removalDate > today || doc.data().removalDate === "")) {
								this.news.push(doc.data());
								this.loading = false;
							} else {
								this.loading = false;
							}
						});
					});
			} catch (err) {
				console.log(err);
			}
		},
	};
</script>
<style scoped>
	.news .news-item {
		border: 1px solid #555555;
		padding: 12.5px;
		margin: 20px;
	}
</style>
